import { Route, Routes } from "react-router-dom";
import "./App.css";
import ProtectedRoute from "./components/common/ProtectedRoute";
import MainLayout from "./components/layout/MainLayout";
import LandingPage from "./pages/LandingPage";
import GalleryPage from "./pages/GalleryPage";
import EventsPage from "./pages/EventsPage";
import LeadershipPage from "./pages/LeadershipPage";
import ContactPage from "./pages/ContactPage";
import AdminLoginPage from "./pages/admin/AdminLoginPage";
import AdminDashboardPage from "./pages/admin/AdminDashboardPage";
import NotFoundPage from "./pages/NotFoundPage";

const App = () => (
  <Routes>
    <Route path="/" element={<MainLayout />}>
      <Route index element={<LandingPage />} />
      <Route path="gallery" element={<GalleryPage />} />
      <Route path="events" element={<EventsPage />} />
      <Route path="leadership" element={<LeadershipPage />} />
      <Route path="contact" element={<ContactPage />} />
      <Route path="admin">
        <Route path="login" element={<AdminLoginPage />} />
        <Route
          path="dashboard"
          element={
            <ProtectedRoute>
              <AdminDashboardPage />
            </ProtectedRoute>
          }
        />
      </Route>
      <Route path="*" element={<NotFoundPage />} />
    </Route>
  </Routes>
);

export default App;
